import { useQuery } from '@tanstack/react-query'
import { fetchPendingTitles } from '@/api/business/unsettledSecurities'
import { UnsettledSecuritiesPendingTitles } from '@/types/UnsettledSecurities'

export const UnsettledSecuritiesPendingTitlesKeys = {
    all: ['unsettled-securities-pendingtitles'] as const,
}

export const useUnsettledSecuritiesPendingTitlesQuery = () => {
    return useQuery<UnsettledSecuritiesPendingTitles[]>({
        queryKey: UnsettledSecuritiesPendingTitlesKeys.all,
        queryFn: fetchPendingTitles,
    })
}
